import CCliente from '@/services/api/cliente/CCliente';
import CUsuario from '@/services/api/usuario/CUsuario';

/**
 * Histórico de acessos (Global)
 */
export default class CPreferenciaCredencialAcessoERP {
  usuario: CUsuario = new CUsuario();
  cliente: CCliente = new CCliente();
  ultimoAcesso: Date = new Date();

  constructor(pObj?: Partial<CPreferenciaCredencialAcessoERP>) {
    Object.assign(this, pObj);
  }
}
